"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as _Builtin from "./_Builtin/index.js";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./Logos.module.css";
const _interactionsData = JSON.parse('{"events":{"e-23":{"id":"e-23","name":"","animationType":"preset","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-24"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1750328136976}},"actionLists":{"a-15":{"id":"a-15","title":"logos-marquee","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":40000,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":-74.625,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-15-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750273292078}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
export function Logos({ as: _Component = _Builtin.Section }) {
    _interactions.useInteractions(_interactionsData, _styles);
    return /*#__PURE__*/ _jsx(_Component, {
        className: _utils.cx(_styles, "sec-logos"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ _jsx(_Builtin.Block, {
            className: _utils.cx(_styles, "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ _jsx(_Builtin.Block, {
                className: _utils.cx(_styles, "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ _jsx(_Builtin.Block, {
                    className: _utils.cx(_styles, "m_container-large"),
                    tag: "div",
                    children: /*#__PURE__*/ _jsxs(_Builtin.Block, {
                        className: _utils.cx(_styles, "comp_hp-logos"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                className: _utils.cx(_styles, "fw1_trusted-label"),
                                tag: "div",
                                children: [
                                    "Trusted by over 60% of the Fortune 500",
                                    /*#__PURE__*/ _jsx("br", {})
                                ]
                            }),
                            /*#__PURE__*/ _jsx(_Builtin.Block, {
                                className: _utils.cx(_styles, "fw1_hero-logos-mask"),
                                tag: "div",
                                children: /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                    className: _utils.cx(_styles, "fw1_hero-logos-moving"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                            className: _utils.cx(_styles, "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                            className: _utils.cx(_styles, "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                            className: _utils.cx(_styles, "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ _jsx(_Builtin.Image, {
                                                    className: _utils.cx(_styles, "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(_Builtin.Block, {
                                className: _utils.cx(_styles, "hp_logos-fade"),
                                tag: "div"
                            }),
                            /*#__PURE__*/ _jsx(_Builtin.Block, {
                                className: _utils.cx(_styles, "hp_logos-fade", "is--right"),
                                tag: "div"
                            })
                        ]
                    })
                })
            })
        })
    });
}
